import { render, staticRenderFns } from "./custEmp.vue?vue&type=template&id=2c16eca7&scoped=true&"
import script from "./custEmp.vue?vue&type=script&lang=js&"
export * from "./custEmp.vue?vue&type=script&lang=js&"
import style0 from "./custEmp.vue?vue&type=style&index=0&id=2c16eca7&prod&lang=scss&scoped=true&"
import style1 from "./custEmp.vue?vue&type=style&index=1&id=2c16eca7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c16eca7",
  null
  
)

export default component.exports